<p>
  view-compart-type-comment works!
</p>
